import type { DoseSpotClinicianKindDto } from '@behuman/core-contract'

/**
 * User-facing names for the kind of a DoseSpot clinician mapping (PD-1592). The kind is
 * detected by the middleware from DoseSpot's roles and only ever *displayed* here; the
 * glossary (`docs/GLOSSARY.md`, "DoseSpot ePrescribing") forbids bare "agent" in copy.
 */
const LABELS: Record<DoseSpotClinicianKindDto, string> = {
  prescriber: 'Prescriber',
  proxy: 'Proxy',
  agent: 'Prescribing Agent',
}

export function describeDoseSpotClinicianKind(kind: DoseSpotClinicianKindDto): string {
  return LABELS[kind]
}
